window.addEventListener('DOMContentLoaded', function () {
    let announcementBar = document.querySelector(
        '#shopify-section-announcement-bar'
    );
    let barClosed = sessionStorage.getItem('announcementBarClosed-v2');
    let closeButton = document.querySelector('.announcement-bar-close');

    let alternativeContent = announcementBar.querySelector('.alternative');

    if (alternativeContent) {
        announcementBar.classList.add('opaque');
    }

    if (barClosed) {
        announcementBar.remove();
        return;
    }

    if (closeButton) {
        closeButton.addEventListener('click', function () {
            announcementBar.classList.add('hide');
            sessionStorage.setItem('announcementBarClosed-v2', true);
        });
    }
});
